<template>
  <v-card>
    <v-toolbar class="elevation-0" height="45" color="gray">
      <v-toolbar-title>
        <h1 class="subheading">Missing Serial Number</h1>
      </v-toolbar-title>
      <v-spacer></v-spacer>
        <h1 class="subheading">{{ inventoryBadge }}</h1>

    </v-toolbar>
    <v-card-text v-if="isLoading">
      <v-progress-linear
        size="70"
        color="pink"
        width="7"
        indeterminate="indeterminate"
      ></v-progress-linear>
    </v-card-text>
    <v-list class="list-500" v-if="!isLoading">
      <template v-for="(row, index) in stockCount">
        <v-list-tile :key="row.id" avatar ripple :to="`/inventory/missingSerialNumber/${row.Product.productID}`">
          <v-list-tile-content>
            <v-list-tile-title>{{ row.Product.productDetail }}</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <span>{{ row.ProductCount }}</span>
          </v-list-tile-action>
        </v-list-tile>
        <v-divider v-if="index + 1 < stockCount.length" :key="index"> </v-divider>
      </template>
    </v-list>
  </v-card>
</template>

<script>
import inventoryService from "../service.js";

export default {
  data() {
    return {
      stockCount: [],
      isLoading: true,
      inventoryBadge: 0,
    };
  },
  methods: {
    getMissingSerialList() {
      inventoryService.getMissingSerialList().then(result => {
        console.log("MissingSerialNumber", result);
        this.stockCount = result.data;
        let total  = 0
        result.data.map(row => {
          total += row.ProductCount
        })
        this.inventoryBadge = total
        this.isLoading = false;
      });
    }
  },
  mounted() {
    this.getMissingSerialList();
  }
};
</script>

<style scoped></style>
